// @ts-ignore
/* eslint-disable */
// API 更新时间：
// API 唯一标识：
import { history } from '@umijs/max';
import axios from 'axios';
// @ts-ignore
import * as api from './api';
import * as login from './login';
import { v4 as uuidv4 } from 'uuid';
export const getToken = () => {
  const REACT_APP_AUTH_TYPE = process.env.REACT_APP_AUTH_TYPE;
  let tokenType = 'BACK_OFFICE';
  if (REACT_APP_AUTH_TYPE === 'COGNITO') {
    tokenType = 'COGNITO';
  }

  if (!localStorage.getItem('token')) {
    return {};
  }

  return {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
      RefreshToken: 'Bearer ' + localStorage.getItem('refreshToken'),
      type: tokenType,
    },
  };
};

export const getBrowserUniqueId = () => {
  let uniqueId: string | null = localStorage.getItem('uniqueId');
  if (!uniqueId) {
    uniqueId = uuidv4();
    if (typeof uniqueId === 'string') {
      localStorage.setItem('uniqueId', uniqueId);
    }
  }
  return uniqueId;
};


export let baseURL = 'https://api.lucky4uexims.com';
// export let baseURL = 'http://localhost:8040';
export const apiRequest = axios.create({
  baseURL,
});
let x = axios.create({
  baseURL,
})
export const apiRequestAuth = x
export const registerAuthInterceptors = () => {
  x.interceptors.request.use(function (config:any) {
    const token = localStorage.getItem('token');
    if (config?.headers) {
      config.headers.Authorization = token ? `Bearer ${token}` : '';
    }
    return config;
  });

  x.interceptors.response.use(
    (resp) => {
      if (resp?.headers?.refreshtoken) {
        localStorage.setItem('token', resp?.headers?.token);
        localStorage.setItem('refreshToken', resp?.headers?.refreshtoken);
      }

      return resp;
    },
    (resp) => {
      return resp;
    },
  );
};

function logOutOn401() {
  let {localStorage} = window;

  apiRequestAuth.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        history.push(`/user/login`);
        // window.location.reload()
      }

      return error;
    },
  );
}

// logOutOn401();
registerAuthInterceptors();
export default {
  api,
  login,
};
